var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check"},[(_vm.type === 0)?_c('jsCheck'):_c('serverCheck')],1)}
var staticRenderFns = []

export { render, staticRenderFns }